'use client';

import { useState } from 'react';
import styles from './FAQ.module.css';

const faqItems = [
    {
        question: 'Berapa lama estimasi waktu pengiriman barang?',
        answer: 'Estimasi waktu pengiriman tergantung pada jenis layanan dan rute. Cargo Udara memakan waktu 1-2 hari, Cargo Darat 2-7 hari (tergantung jarak kota), dan Cargo Laut 5-14 hari (tergantung jadwal keberangkatan kapal ke pulau tujuan).'
    },
    {
        question: 'Apakah barang kiriman dilindungi oleh asuransi?',
        answer: 'Ya, kami sangat merekomendasikan penggunaan asuransi untuk setiap pengiriman. PT Trans Nusa Pasifik bekerja sama dengan perusahaan asuransi terkemuka untuk memberikan perlindungan komprehensif (All Risk) dari keberangkatan hingga barang tiba di tujuan.'
    },
    {
        question: 'Bagaimana cara melacak status pengiriman barang saya?',
        answer: 'Setiap pengiriman akan mendapatkan nomor resi (Waybill). Anda dapat melacak status pengiriman secara real-time melalui fitur Tracking di website kami atau dengan menghubungi Customer Service 24/7 kami.'
    },
    {
        question: 'Apakah melayani pengiriman door-to-door?',
        answer: 'Tentu. Layanan unggulan kami adalah Door-to-Door service, di mana kami akan menjemput barang dari lokasi Anda (kantor/gudang) dan mengirimkannya langsung sampai ke alamat tujuan akhir penerima tanpa biaya tersembunyi.'
    },
    {
        question: 'Jenis barang apa saja yang tidak bisa dikirim?',
        answer: 'Kami mematuhi regulasi pemerintah yang berlaku. Kami tidak menerima pengiriman barang terlarang seperti narkotika, senjata api, barang pecah belah tanpa packing kayu standar, barang mudah terbakar tanpa deklarasi (DG), dan makhluk hidup (tanpa izin karantina khusus).'
    }
];

export default function FAQ() {
    const [openIndex, setOpenIndex] = useState<number | null>(0);

    const toggleAccordion = (index: number) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <section className={`section ${styles.faq}`}>
            <div className="container">
                <div className="section-header reveal">
                    <span className="section-label">FAQ</span>
                    <h2 className="section-title">Pertanyaan yang Sering Diajukan</h2>
                    <p className="section-subtitle">
                        Temukan jawaban cepat untuk pertanyaan umum seputar layanan ekspedisi kami.
                    </p>
                </div>

                <div className={`${styles.accordionWrapper} reveal`}>
                    {faqItems.map((item, index) => {
                        const isOpen = openIndex === index;
                        return (
                            <div key={index} className={`${styles.accordionItem} ${isOpen ? styles.open : ''}`}>
                                <button
                                    className={styles.accordionHeader}
                                    onClick={() => toggleAccordion(index)}
                                    aria-expanded={isOpen}
                                >
                                    <span className={styles.question}>{item.question}</span>
                                    <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className={styles.icon}
                                    >
                                        <polyline points="6 9 12 15 18 9"></polyline>
                                    </svg>
                                </button>
                                <div className={styles.accordionCollapse}>
                                    <div className={styles.accordionBody}>
                                        <p>{item.answer}</p>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
